import { Reveal } from "./Reveal";

export default function SectionHeading({ eyebrow, title, intro, align = "left", id }) {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <Reveal className={`flex flex-col gap-5 max-w-3xl ${alignCls}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2
        id={id}
        className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.08]"
      >
        {title}
      </h2>
      {intro && <p className="text-base md:text-lg text-zinc-400 leading-relaxed">{intro}</p>}
    </Reveal>
  );
}